import { DatePipe } from "@angular/common";
import { Component, OnDestroy,ElementRef, ChangeDetectorRef, ViewChild, Input, Output, EventEmitter } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { CheckoutFacade } from "src/app/libs/data-access/services/checkout/services/checkout.facade";
import { RouterService } from "src/app/libs/data-access/services/router/router.service";
import { FormsMetadata } from "src/app/libs/ui/components/search-form/consts/form-metadata.const";
import { FindTripFormGroupInterface } from "src/app/libs/ui/components/search-form/interfaces/form-metadata.interface";
import { HomePageUtils } from "src/app/pages/home-page/src/app/ui/utils/home-page.utils";
import { HotelsFacade } from "src/app/pages/hotels/data-access/services/hotels.facade";
import { PagesRoute } from "src/app/pages/src/app/ui/routes/routes.enum";
import { ImageGalleryComponent } from "../image-gallery/image-gallery.component";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { OfflineDialogComponent } from "src/app/libs/ui/components/offline-dialog/offline-dialog.component";
import { IOnConfirmEmitter } from "../../data-access/model/interfaces/hotels-results-card.interface";
import { ViewGoogleMapComponent } from "../../ui/components/view-google-map/view-google-map.component";
import { SharedService } from "src/app/libs/common/services/shared.service";

declare var $: any;
@Component({
  selector: "tic-room-detail",
  templateUrl: "./room-detail.component.html",
  styleUrls: ["./room-detail.component.scss"],
})

export class RoomDetailComponent implements OnDestroy {
  @Output() mapView: EventEmitter<IOnConfirmEmitter> = new EventEmitter();
  @Input() viewRoomId: any;
  params:any;
  boards: any;
  data: any;
  loadedHotel: any = {};
  loadedRoom: any = {};
  loadRoomImages: any = [];
  private destroy$ = new Subject();
  loadedHotelFlag: boolean = false;
  totalCost: number = 0;
  orignalCost: number = 0;
  selectedRoomOptions: string = "";
  selectedRoomOptionsPrice = 0;
  paramRoomOptions: any = {};
  roomOptions: any[] = [];
  roomRates:any=[];
  oppopup = false;
  boardList: any;
  eventData!: any;
  flightData!: any;
  hotelData!: any;
  currency!: string;
  totalRoomPrice: number = 0;
  packageType = [
    'summaryCard.packageType.TicketFlightHotel',
    'summaryCard.packageType.TicketFlight',
    'summaryCard.packageType.TicketHotel',
   ];
  packageIndex!: number;
  selectedRoomData: any;
  totalPeoples: any;
  daysBetween: number;
  eventPrice: number = 0;
  flightPrice: number = 0;
  isPriceReset: boolean;
  cartRoomPrice: number = 0;
  boardPrice: number = 0;

  constructor(
    private routerService: RouterService,
    public facade: HotelsFacade,
    private el: ElementRef,
    public facadeCheckout: CheckoutFacade,
    private ref: ChangeDetectorRef,
    private dialog :MatDialog,
    private routes: Router,
    private _sharedService:SharedService
  ) { }

  ngOnInit() {
    this.setInitialState();
  }
  
  private getUniqueItems(items: any[], propertyName: string): any[] {
    const uniqueItems: any[] = [];
    if (items) {
      items.forEach((item) => {
        if (
          !uniqueItems.some(
            (uniqueItem) => uniqueItem[propertyName] === item[propertyName]
          )
        ) {
          uniqueItems.push(item);
        }
      });
    }

    return uniqueItems;
  }

  private setInitialState(): void {
    this.routerService
      .getUrlParams()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        const startDate = new Date(res['inboundDate']);
        const endDate = new Date(res['outboundDate']);
        this.daysBetween = this.getDates(startDate, endDate);
        this.params = res;
        this.data = res;
        this.packageIndex = res['packageType'];
        this.totalPeoples = parseInt(res['numberOfAdults']) + parseInt(res['numberOfChildren']);
        this.data = HomePageUtils.finalizedObjectData(this.data);
        this.params = { ...this.data, ...res };
    });
    this.facadeCheckout.hotel$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.loadedHotel = res
      this.loadRoomImages = this.loadedHotel.images.filter(
        (imageObject: any) => imageObject?.roomCode === this.viewRoomId
      );
      this.loadedHotel.rooms.find((room: any) => {
      if (
        room.roomCode === this.viewRoomId
      ) {
        
        this.loadedRoom = room;
        this.loadedHotelFlag = true;
        this.isPriceReset=true;          
      }
      });
    });
    this.facadeCheckout.room$.pipe(takeUntil(this.destroy$)).subscribe((room) => { 
      if( room && Object.keys(room).length != 0 ) {
        this.cartRoomPrice = this.getNumericRoomPrice(room);
        this.createBoardList(room);
      }
    });
    this.facadeCheckout.vm$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if(data && data.events && data.events.length > 0){
        this.eventData = data.events;
        this.currency = data.events[0].currency;
      }
      if(data && data.flight){
        this.flightData = data.flight;
      }
      if(data && data.hotel){
        this.hotelData = data.hotel;
      }
      if(data && data.totalPrice){
        this.totalCost = data.totalPrice;
        this.orignalCost = data.totalPrice;
      }
      if(data && data.eventPrice) {
        this.eventPrice = data.eventPrice;
      }
      if(data && data.flightPrice) {
        this.flightPrice = data.flightPrice;
      }
      this.ref.detectChanges();
      if(this.isPriceReset){
        this.totalCost = this.eventPrice + this.flightPrice + this.totalRoomPrice;
        this.isPriceReset=false;
      }
    });
  }

  private createBoardList(room: any) {
    this.roomRates = this.getUniqueItems(this.loadedRoom?.rates, "boardName");
    this.boards = this.loadedHotel.boards;
    this.boardList = this.boards.map((board: any) => {
      const matchingRate = this.roomRates.find((rate: any) => board.code === rate.boardCode);
      let price = null;
      let include = false;
      if (matchingRate) {
        price = matchingRate.actualPrice - this.cartRoomPrice;
      }

      if ( this.loadedRoom.roomCode == room.roomCode && board.code === room.boardCode) {
        include = true;
        this.boardPrice = price;
        this.totalRoomPrice = room.price;
        this.selectedRoomData = {
          name: room.name,
          boardName: room.boardName,
          code: room.boardCode,
          price: room.price
        };
      }
      return {
        boardCode: board.code,
        boardName: board.description.content,
        include: include,
        disabled: !!matchingRate, 
        price: price,
        actualPrice: matchingRate?.actualPrice
      };
    })
    .sort((a: any, b: any) => {
      if (a.boardCode === 'RO') return -1;
      if (b.boardCode === 'RO') return 1;
      return 0;
    });
    if ( this.loadedRoom.roomCode != room.roomCode ) {
      this.boardPrice = this.boardList[0].price;
    }
    this.ref.detectChanges();
  }

  getNumericRoomPrice(room: any): number {
    const match = String(room?.price).match(/-?[\d,.]+/);
    return match ? parseFloat(match[0].replace(/,/g, '')) : 0;
  }

  isObjectNotEmpty(obj: any): boolean {
    return obj && Object.keys(obj).length > 0;
  }

  checkCheckBoxvalue(event: any,index: number, additionalPrice: number, roomPrice: number, roomName: any, roomCode: any) {
    if(event.target.checked)
    {
      this.boardList.forEach((board: any, i: number) => {
        if (i !== index && board.disabled ) {
          board.include = false;
        }
      });
      this.totalRoomPrice = roomPrice;
      this.totalCost = this.eventPrice + this.flightPrice + this.totalRoomPrice;
      this.boardPrice = additionalPrice;
      this.selectedRoomData = {
        name: this.loadedRoom.apartmentDescription,
        boardName: roomName,
        boardCode: roomCode,
        roomCode:this.loadedRoom.roomCode,
        price: this.totalRoomPrice
      }
    } else{
      this.boardList.forEach((board: any, i: number) => {
        if (i !== index && board.disabled ) {
          board.include = true;
        }
      });
    }
  }

  scrollTo(target: HTMLElement) {
    target.scrollIntoView({ behavior: "smooth" });
  }

  getDates(startDate: Date, endDate: Date): number {
    const startMillis = startDate.getTime();
    const endMillis = endDate.getTime();
    const differenceMillis = endMillis - startMillis;
    const differenceDays = differenceMillis / (1000 * 60 * 60 * 24);
    return Math.round(differenceDays);
  }

  onSelectedRoom(room: any): void {
    if ( !navigator.onLine ) {
      this.dialog.open(OfflineDialogComponent);
      return;
    }
    if(this.selectedRoomData){    
    //const updatedPrice = this.totalCost;
    let updatedPrice;
    updatedPrice = this.eventPrice + this.flightPrice + this.totalRoomPrice;
    this.facadeCheckout.setTotalPrice(updatedPrice);
    this.facadeCheckout.setRoom(this.selectedRoomData);
    localStorage.setItem('selectedRoom',this.selectedRoomData.roomCode);
    this.facadeCheckout.setHotelPrice(this.totalRoomPrice);
    const currentUrlTree = this.routes.parseUrl(this.routes.url);
    const currentQueryParams = currentUrlTree.queryParams;
    const base64Data = this.objectToBase64(this.selectedRoomData);
    this.routerService.navigateAndAddParamsToUrl(
      {
        ...currentQueryParams,
        roomData: base64Data
      },
      false,
      PagesRoute.TripSummary
    );
  }else{
  this._sharedService.Error('Select room board first!')
  }
  }

  objectToBase64(obj: any): string {
    const jsonStr = JSON.stringify(obj);
    return btoa(jsonStr);
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  openpopup() {
    this.dialog.open(ImageGalleryComponent,{width:"65%", data:{images: this.loadRoomImages}})
  }
  private initSlickSlider() {
    $(this.el.nativeElement).find('.gallery-carousel').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      loop: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ]
    });
  }
  closepopup()
  {
    this.oppopup = false;
  }
  onSubmitSearchForm(formDetails: FindTripFormGroupInterface): void {
    let copyFormDetails: any = { ...formDetails };
    const pipe = new DatePipe("en-US");
    copyFormDetails.inboundDate = pipe.transform(
      copyFormDetails.inboundDate,
      "yyyy-MM-dd"
    );
    copyFormDetails.outboundDate = pipe.transform(
      copyFormDetails.outboundDate,
      "yyyy-MM-dd"
    );
    copyFormDetails.destinationLocationCode =
      FormsMetadata.destination.optionsArray.find(
        (item) => item.displayName === formDetails.destinationLocationCode
      )?.value as string;
    copyFormDetails.originLocationCode = FormsMetadata.origin.optionsArray.find(
      (item) => item.displayName === formDetails.originLocationCode
    )?.value as string;
    if(copyFormDetails.paxesChildrenAges!=="null"){
      copyFormDetails.paxesChildrenAges = JSON.stringify(
        copyFormDetails.paxesChildrenAges
      );
    }
    
    const finalizedObject =HomePageUtils.finalizedObjectData(copyFormDetails);
    const finalizedObjectTemp =HomePageUtils.finalizedObjectDataTemp(copyFormDetails);
    let forwardRoute = PagesRoute.EventPage;
    this.routerService.navigateAndAddParamsToUrl(
      finalizedObjectTemp,
      true,
      forwardRoute
    );
  }

  showMapPopupHandler() {
         this.dialog.open(ViewGoogleMapComponent,{
            data: { hotel:this.loadedHotel },
            width: '80vw',
        height: '80vh',
        panelClass: 'default-dialog'
          });
          return;
      }
}
